import supabase from '../../config/supabaseClient';
import { useEffect, useState } from 'react';

const Bulletin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [fetchError, setFetchError] = useState(null);
  // states for edit input
  const [editTitle, setEditTitle] = useState("")
  const [editDate, setEditDate] = useState("");
  const [editTime, setEditTime] = useState("");
  const [editDetail, setEditDetail] = useState("");
  const [editFileName, setEditFileName] = useState("");


  
  useEffect(() => {
    const checkAuth = async () => {
      const user = await supabase.auth.getUser();
      setIsAuthenticated(!!user.data.user);
      console.log("Auth!!", !!user.data.user);
    };
    checkAuth();
  }, []);

  const [events, setEvents] = useState([]);

  // Function to fetch events
  const fetchEvents = async () => {
    const today = new Date();
    const localDateString = today.getFullYear() + '-' + 
      String(today.getMonth() + 1).padStart(2, '0') + '-' + 
      String(today.getDate()).padStart(2, '0');

    const { data, error } = await supabase
      .from('events')
      .select('*')
      .gte('date', localDateString);

    if (error) {
      setFetchError('Could not fetch events');
      setEvents([]);
      console.log(error);
    }

    if (data) {
      // order events by date ascending
      // keep the original date string to avoid timezone issues
    
      setEvents(data);
      setFetchError(null);
      console.log('Database Events:', data);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

 

  const CreateEvent = async (e) => {
    e.preventDefault();
    console.log("Create Event was called");
    console.log(editFileName)
    e.target.querySelector('button[type="submit"]').textContent = "Uploading Please wait...";
    e.target.querySelector('button[type="submit"]').disabled = true;
    // button gray;
    e.target.style.background = "gray";
    let StorageLink = "";

    const fileInput = e.target.querySelector('input[type="file"]');
    const file = fileInput?.files?.[0];
    console.log(file);

    // Create a formatted timestamp for the filename
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5); // Format: YYYY-MM-DDTHH-MM-SS
    const fileExtension = file.name.split('.').pop();
    const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
    const uniqueFileName = `${fileNameWithoutExt}_${timestamp}.${fileExtension}`;

    const { data, error } = await supabase.storage
      .from('events')
      .upload(uniqueFileName, file);
      

    if (error) {
      console.log(error);
    } else {
      console.log(data);
      const { data: signedUrlData, error: signedUrlError } = await supabase.storage
      .from('events')
      .createSignedUrl(uniqueFileName, 60 * 60 * 24 * 30); // 1 month in seconds

      if (signedUrlError) {
      console.log("Error creating signed URL:", signedUrlError);
      } else {
      StorageLink = signedUrlData.signedUrl;
      console.log("Signed URL (1 year):", StorageLink);
      setEditFileName(StorageLink)
      
      }
    }

    const { dataForm, errorForm } = await supabase
      .from('events')
      .insert([
        {
          title: editTitle,
          date: editDate,
          time: editTime,
          detail: editDetail,
          fileName: StorageLink,
        }
      ])
      .select();

    if (dataForm) {
      console.log("Event created successfully:", dataForm);
      // Clear form fields
      setEditTitle("");
      setEditDate("");
      setEditTime("");
      setEditDetail("");
      setEditFileName("");
      
      // Refetch events to update the list
    }

    if (errorForm) {
      console.log("Error creating event:", errorForm);
    }

    e.target.querySelector('button[type="submit"]').textContent = "Add Event";
      e.target.querySelector('button[type="submit"]').disabled = false;
    e.target.style.background = "#79A27D"; // Reset the button background
       fetchEvents();

  };

  const deleteHandler = async (e, id) => {
    e.preventDefault(); // Prevent default form submission behavior
    console.log("Delete was called", id);

    const { error } = await supabase
      .from('events')
      .delete()
      .eq('id', id); // Replace 'id' with the actual column name if different

    if (error) {
      console.error("Error deleting event:", error);
    } else {
      console.log("Event deleted successfully");
      setEvents((prevEvents) => prevEvents.filter((event) => event.id !== id)); 
      
    }
  };
  

  return (
    <div className="Announcements-ViewPage">
      <h1>Announcements</h1>

      {/* render form if isAuthenticated */}
      {isAuthenticated && (
        <div>
          <form onSubmit={CreateEvent} className='eventForm'>
            <p>+ add a new event</p>
            {/* <div>
              <input
                type="text"
                id="title"
                name="title"
                placeholder="Title: (optional)"
                value={editTitle}
                onChange={(e) => setEditTitle(e.target.value)}
              />
            </div> */}
            
            {/* <div>
              <input
                type="text"
                id="time"
                name="time"
                placeholder="Time: (Optional)"
                value={editTime}
                onChange={(e) => setEditTime(e.target.value)}
              />
            </div> */}
            {/* <div>
              <textarea
                id="detail"
                name="detail"
                placeholder="Detail: (Optional)"
                value={editDetail}
                onChange={(e) => setEditDetail(e.target.value)}
              ></textarea>
            </div> */}
            <div>
              <input
                type="file"
                id="fileName"
                name="fileName"
                placeholder="Image File Name"
                onChange={(e) => setEditFileName(e.target.files[0]?.name || "")}
              />
            </div>

            <div>
              <input
                type="date"
                id="date"
                name="date"
                placeholder="Expiration Date"
                required
                value={editDate}
                onChange={(e) => setEditDate(e.target.value)}
              />
            </div>

            <button type="submit" className='MainBTN'>Add Event</button>
          </form>
        </div>
      )}

      {fetchError && <p>{fetchError}</p>}
      {events.length > 0 && (
        <ul>
          {events
            .slice()
            .sort((a, b) => {
              // Parse dates and compare
              const dateA = new Date(a.date);
              const dateB = new Date(b.date);
              return dateA - dateB;
            })
            .map((event) => (
              <li key={event.id}>
                <p className="hidden">{event.orderNumber}</p>
                <div className="event-details">
                   <h3>{new Date(event.date + 'T00:00:00').toLocaleDateString('en-US', { 
                    weekday: 'long', 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                    })}</h3>
                  <img
                  src={`${event.fileName}`}
                  alt={event.title}
                
                />
                </div>
                
                {isAuthenticated ? (
                  <div>
                    <button id={event.id}>Edit</button>
                    <button id={event.id} onClick={(e) => deleteHandler(e, event.id)}>Delete</button>
                  </div>
                ) : null}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default Bulletin;
